// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmFirstModal_modal__4WB-V","card":"ConfirmFirstModal_card__AOVJJ"};